import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

const NON_CACHEABLE_TYPENAMES = Object.freeze([
  'lp_ReleaseFormat',
]);

function nonCacheable(typename: string): boolean {
  return NON_CACHEABLE_TYPENAMES.indexOf(typename) > -1;
}

export const cacheOptions = {
  fragmentMatcher: new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
      __schema: {
        types: [
          {
            kind: 'UNION',
            name: 'HydratedFacet',
            possibleTypes: [
              {
                name: 'Brand',
              },
              {
                name: 'Category',
              },
            ],
          },
          {
            kind: 'UNION',
            name: 'FeedEntry',
            possibleTypes: [
              {
                name: 'Article',
              },
              {
                name: 'Listing',
              },
            ],
          },
        ],
      },
    },
  }),
  dataIdFromObject: (result: any) => {
    if (result.__typename) {
      if (nonCacheable(result.__typename)) {
        return null;
      }
      if (result._id !== undefined) {
        return `${result.__typename}:${result._id}`;
      }
      if (result.uuid !== undefined) {
        return `${result.__typename}:uuid:${result.uuid}`;
      }
      if (result.id !== undefined) {
        return `${result.__typename}:id:${result.id}`;
      }
    }
    return null;
  },
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/apollo_client.ts